import { InjectionToken } from '@angular/core';

export interface FeatureUserConfiguration {
  authApiUrl: string;
}

export const FEATURE_USER_CONFIGURATION = new InjectionToken(
  'FEATURE_USER_CONFIGURATION'
);
